<template>
    <div>

        <Row style="border-left: 5px solid #009688;margin-bottom: 5px">
            <Col span="4">销售额: <Tag color="error">{{ countData.total_price }} 元</Tag>
            </Col>
            <!-- <Col span="4">平台收入: <Tag color="error">{{ countData.plate_income }} 元</Tag>
            </Col> -->
            <Col span="4">待退款订单: {{ countData.wait_settlement_amount || 0 }}</Col>
            <Col span="4">累计优惠金额: {{ countData.discount_amount || 0}}</Col>
        </Row>

        <pageTable ref="table" :tableTitle="tableColumn" :searchData="searchData" :doneFunction="doneFunction"
            tableApi="admin/order/getCompanyOrderListsForAgent">
            <template v-slot:searchFormItem>
                <FormItem prop="id">
                    <Input type="text" v-model="searchData.id" placeholder="ID" class="lx-search-item"></Input>
                </FormItem>
                <FormItem prop="order_no">
                    <Input type="text" v-model="searchData.order_no" placeholder="订单号|上游|下游"
                        class="lx-search-item"></Input>
                </FormItem>
                <FormItem prop="car_number">
                    <Input type="text" v-model="searchData.car_number" placeholder="车牌号" class="lx-search-item"></Input>
                </FormItem>
                <FormItem prop="station_id">
                    <Select v-model="searchData.station_id" :filterable="true" :remote-method="getStationsByName"
                        :loading="isLoadingStation" placeholder="站点" clearable>
                        <Option v-for="item in stations" :value="item.station_id" :key="item.station_id">{{ item.name }}
                            -- {{ item.platform }}</Option>
                    </Select>
                </FormItem>
                <FormItem prop="company_id">
                    <Select v-model="searchData.company_id" :filterable="true" placeholder="车队" clearable>
                        <Option v-for="item in companys" :value="item.id" :key="item.company_id">{{ item.name }}
                        </Option>
                    </Select>
                </FormItem>


                <FormItem prop="platform">
                    <Select v-model="searchData.platform" placeholder="渠道" clearable>
                        <Option v-for="(item, key) in platform" :value="item.id" :key="key">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <FormItem prop="refund_status">
                    <Select v-model="searchData.refund_status" placeholder="退款状态" clearable>
                        <Option value="1">退款中</Option>
                        <Option value="5">已退款</Option>
                    </Select>
                </FormItem>
                <FormItem prop="create_time">
                    <DatePicker v-model="searchData.create_time" type="datetimerange" @on-change="timeChange"
                        placeholder="购买时间" style="width: 320px"></DatePicker>
                </FormItem>
            </template>

            <template v-slot:otherBtn>
                <FormItem>
                    <Button type="primary" @click="exportData">导出</Button>
                </FormItem>
            </template>

        </pageTable>

        <userEditForm v-if="showUserDetail" :show-edit="showUserDetail" :user_id="editUserId" ref="editModel"
            @cancel-edit="showUserDetail = false">
        </userEditForm>

        <orderDetail v-if="showOrderDetail" :show-edit="showOrderDetail" :order_id="editOrderId" ref="orderDetail"
            @cancel-edit="showOrderDetail = false">
        </orderDetail>


    </div>
</template>

<script>
import pageTable from "@/components/table/pageTable";
import userEditForm from "../user/edit";
import orderDetail from "./detail";
import XLSX from 'xlsx'

export default {
    name: "lists",
    components: { pageTable, userEditForm, orderDetail },
    data() {
        return {
            editUserId: 0,     //编辑的ID
            showUserDetail: false,
            editOrderId: 0,     //编辑的ID
            showOrderDetail: false,
            status: 0,
            searchData: {
                mobile: '',
                nick_name: '',
                car_number: '',
                create_time: '',
                refund_status: '',
                gas_name: '',
                company_id: '',
                export_type: 'ty',
                user_name: '',
                id: '',
                order_no: ''
            },
            tableColumn: [
                {   // id 按照总数的数量 排序 降序
                    title: '序号', key: 'reverse_index_id', width: 90, align: 'center' 
                },
                // {
                //     title: '订单',
                //     key: 'order_id',
                //     align: 'center',
                //     minWidth: 140,
                //     render: (h, params) => {
                //         const items = [
                //             params.row.order_no ? `单号：${params.row.order_no}` : '',
                //             params.row.out_trade_no ? `上游：${params.row.out_trade_no}` : '',
                //             params.row.partner_trade_no ? `下游：${params.row.partner_trade_no}` : ''
                //         ].filter(Boolean).map(text => h('div', text));
                //         return h('div', items);
                //     }
                // },
                {
                    title: '司机信息',
                    key: 'order_id',
                    align: 'center',
                    minWidth: 130,
                    render: (h, params) => {
                        const items = [
                            params.row.user_name ? `姓名：${params.row.user_name}` : '',
                            params.row.user_mobile ? `手机号：${params.row.user_mobile}` : ''
                        ].filter(Boolean).map(text => h('div', text));
                        return h('div', items);
                    }
                },
                {
                    title: '车牌号', key: 'car_number', minWidth: 100, align: 'center'
                },
                {
                    title: '车队', key: 'company_name', minWidth: 100, align: 'center', render: (h, params) => {
                        return h('div', [
                            h('p', params.row.company_name),
                            h('Tag', { props: { color: 'blue' } }, params.row.company_is_bill === 1 ? 'A型' : 'B型'),
                        ])
                    }
                },
                {
                    title: '油站', key: 'gas_name', minWidth: 100, align: 'center', render: (h, params) => {
                        return h('div', [
                            h('p', params.row.gas_name),
                            h('Tag', { props: { color: 'orange' } }, params.row.platform),
                        ])
                    }
                },
                {
                    title: '凭证', key: 'proof', width: 160, minWidth: 100, align: 'center', render: (h, params) => {
                        if (params.row.proof_car === '' && params.row.proof_station === '') {
                            return h('span', '未上传');
                        } else {
                            let content = [];
                            if (params.row.proof_car !== '') {
                                content.push(h('img', {
                                    attrs: { src: params.row.proof_car },
                                    style: {
                                        width: '60px', height: '60px'
                                    },
                                    on: { click: () => { this.showProof(params.row) } }
                                }))
                            }
                            if (params.row.proof_station !== '') {
                                content.push(h('img', {
                                    attrs: { src: params.row.proof_station },
                                    style: {
                                        width: '60px', height: '60px'
                                    },
                                    on: { click: () => { this.showProof(params.row) } }
                                }))
                            }
                            if (params.row.proof_mileage !== '') {
                                content.push(h('img', {
                                    attrs: { src: params.row.proof_mileage },
                                    style: {
                                        width: '60px', height: '60px'
                                    },
                                    on: { click: () => { this.showProof(params.row) } }
                                }))
                            }
                            return h('div', content)
                        }
                    }
                },
                {
                    title: '数量(升)', key: 'litre_num', minWidth: 70, align: 'center'
                },
                {
                    title: '车队金额', key: 'total_price', minWidth: 100, align: 'center', render: (h, params) => {
                        return h('span', `${params.row.company_price} * ${params.row.litre_num} = ${params.row.company_amount}`)
                    }
                },
                {
                    title: '车队单价', minWidth: 80, align: 'center', key: 'company_price'
                },
                // {
                //     title: '挂牌价', minWidth: 80, align: 'center', key: 'station_price'
                // },
                {
                    title: '优惠金额', minWidth: 140, align: 'center', key: '',render: (h, params) => {
                        let discount_amount = 0;
                        if(params.row.ndrc_price) {
                            discount_amount = ((params.row.ndrc_price - params.row.company_price) * params.row.litre_num).toFixed(2);
                            return h('span', `(${params.row.ndrc_price} - ${params.row.company_price})* ${params.row.litre_num} = ${discount_amount}`)
                        }
                    }
                },
                {
                    title: '收款方式', key: 'pay_by_name', minWidth: 90, align: 'center'
                },
                {
                    title: '下单时间', key: 'create_time', minWidth: 100, align: 'center', width: 170
                },
                {
                    title: '操作', minWidth: 100, align: 'center', width: 120, fixed: 'right', render: (h, params) => {
                        if (params.row.refund_status === 0 && params.row.order_status === 5) {
                            return h('Button', { props: { type: 'error', size: 'small' }, on: { click: () => { this.refund(params.row.order_id) } } }, '退款')
                        } else if (params.row.refund_status === 1) {
                            return h('div', [
                                h('p', '退款中'),
                                h('p', [
                                    h('Button', { props: { type: 'primary', size: 'small' }, on: { click: () => { this.cancelRefund(params.row.order_id) } } }, '驳回'),
                                    h('Button', { props: { type: 'error', size: 'small' }, on: { click: () => { this.refund(params.row.order_id) } } }, '退款'),
                                ])
                            ])
                        } else if (params.row.refund_status === 5) {
                            return h('span', '已退款')
                        } else {
                            return h('span', '未知状态')
                        }
                    }
                },
            ],
            tableData: [],
            countData: {},
            stations: [],
            isLoadingStation: false,
            companys: [],
            platform: [],
            refundRemark: '',
        }
    },
    methods: {
        showDetail(order_id) {
            this.editOrderId = order_id
            this.showOrderDetail = true
        },
        showUserDetailPage(user_id) {
            this.showUserDetail = true
            this.editUserId = user_id
        },
        reloadDetail(user_id) {
            this.showUserDetail = false
            this.$nextTick(() => {
                this.showUserDetailPage(user_id)
            })
        },
        doneFunction() {
            // this.countData = res.extra
            // 判断seachData的company_id是否变化，变化则重新获取统计数据
            this.getCompanyOrderCountForAgent()
        },
        exportData() {
            this.$commonFun.postProxy('admin/order/exportCompanyOrderForAgent', this.searchData).then((res) => {
                this.$commonFun.dealApiResult(res, () => {
                    let worksheet = XLSX.utils.aoa_to_sheet(res.data)
                    let workbook = XLSX.utils.book_new()
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'sheet1')
                    XLSX.writeFile(workbook, `车队订单.xlsx`)
                })
            })
        },
        showProof(info) {
            let images = [];
            if (info.proof_car !== '') images.push(info.proof_car);
            if (info.proof_station !== '') images.push(info.proof_station);
            if (info.proof_mileage !== '') images.push(info.proof_mileage);
            this.$viewerApi({
                images: images,
                options: {
                    initialViewIndex: 0,
                },
            })
        },
        refund(order_id) {
            this.$Modal.confirm({
                title: '退款',
                render: (h) => {
                    return h('Input', {
                        size: "large",
                        modelValue: this.refundRemark,
                        autofocus: true,
                        placeholder: '请输入退款原因',
                        on: {
                            input: (val) => {
                                this.refundRemark = val;
                            }
                        }
                    })
                },
                loading: true,
                onOk: async () => {
                    let res = await this.$commonFun.postProxy('admin/order/refund', { order_id, remark: this.refundRemark });
                    this.$Modal.remove()
                    this.$commonFun.dealApiResult(res, () => {
                        this.$commonFun.successTip(res.msg, () => {
                            this.$refs.table.getLists();
                        })
                    })
                }
            })
        },
        cancelRefund(order_id) {
            this.$Modal.confirm({
                title: '驳回退款',
                loading: true,
                onOk: async () => {
                    let res = await this.$commonFun.postProxy('admin/order/cancelRefund', { order_id });
                    this.$Modal.remove()
                    this.$commonFun.dealApiResult(res, () => {
                        this.$commonFun.successTip(res.msg, () => {
                            this.$refs.table.getLists();
                        })
                    })
                }
            })
        },
        async getStationsByName(query) {
            if (!query) return;
            let params = { name: query }
            this.isLoadingStation = true
            let res = await this.$commonFun.postProxy('admin/order/getStationsByName', params)
            this.isLoadingStation = false
            if (res && res.data) {
                this.stations = res.data
            }
        },
        timeChange(time) {
            console.log(time)
            if (time[1].slice(-8) === '00:00:00') {
                time[1] = time[1].slice(0, -8) + '23:59:59'
                this.searchData.create_time = time
            }
        },
        // 从路由参数同步筛选条件到 searchData（只赋值不请求）
        // created 阶段调用，保证 pageTable 首次加载就携带条件；watch 中调用后手动触发刷新
        applyQueryToSearchData() {
            const { create_time, refund_status } = this.$route.query;
            if (create_time) {
                const times = String(create_time).split(',');
                if (times.length === 2 && times[0] && times[1]) {
                    this.searchData.create_time = times;
                }
            }
            if (refund_status) {
                this.searchData.refund_status = String(refund_status);
            }
        },
        // keep-alive 缓存页面再次进入时：重置旧条件 -> 应用新条件 -> 触发搜索
        refreshByQuery() {
            this.searchData.create_time = '';
            this.searchData.refund_status = '';
            this.applyQueryToSearchData();
            this.$nextTick(() => {
                if (this.$refs.table) {
                    this.$refs.table.searchAndResetPage();
                }
            });
        },
        //获取统计数据
        getCompanyOrderCountForAgent() {
            this.$commonFun.postProxy('admin/order/getCompanyOrderCountForAgent', { company_id: this.searchData.company_id || 0 }).then((res) => {
                this.$commonFun.dealApiResult(res, () => {
                    this.countData = res.data
                })
            })
        }
    },
    watch: {
        // keep-alive 缓存页面时，工作台带新条件再次进入也刷新筛选
        '$route.query'() {
            this.refreshByQuery();
        }
    },
    created() {
        // 子组件挂载前同步条件，pageTable 首次请求即携带筛选条件
        this.applyQueryToSearchData();
    },
    mounted() {
        this.$commonFun.postProxy('admin/common/getPageInitInfo', { type: ['companys', 'platform'] }).then((res) => {
            this.companys = res.data.companys
            this.platform = res.data.platform
        })
    },
}
</script>

<style scoped></style>
